import { useTable } from 'react-table';

export default function BasicTableComponent({
  columns,
  data,
  showClickableRows,
  ...props
}) {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({
      columns,
      data,
    });

  return (
    <table
      className={`table table-striped ${
        showClickableRows ? 'table-hover' : ''
      }`}
      {...getTableProps()}
    >
      <thead>
        {headerGroups.map((headerGroup) => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column) => (
              <th {...column.getHeaderProps()}>{column.render('Header')}</th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map((row, i) => {
          prepareRow(row);
          return (
            <tr {...row.getRowProps()}>
              {row.cells.map((cell, index, arr) => {
                return (
                  <td
                    {...cell.getCellProps()}
                    onClick={
                      index < arr.length - 1
                        ? () => {
                            props.onRowClick(row.original.id);
                          }
                        : () => {}
                    }
                  >
                    {cell.render('Cell')}
                  </td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
